import { Preview } from "../../../types/IAction";

// Interfaz esperada por los dispatchers
export interface ReferidosLicenciasReporteDispatcher {}

export const referidosLicenciasReporteDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => ReferidosLicenciasReporteDispatcher = dispatch => ({});
